export default __webpack_public_path__ + "static/media/Background_00032.7ca3f60a.png";